import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { Switch } from '@mui/material';
import styles from './AddCategory.module.css';
import ServiceCategoryTable from '../components/ServiceCategoryTable';
import APIURL from '../api/apiClient';

function AddServiceCategory() {
    const [formData, setFormData] = useState({
        name: '',
        brand: '',
        status: 1,
        featured: '',
    });

    const [errorMessage, setErrorMessage] = useState('');
    const fileInputRef = useRef(null);

    const validate = () => {
        if (!formData.name.trim()) {
            setErrorMessage('Name is required.');
            return false;
        }
        setErrorMessage('');
        return true;
    };

    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;

        if (type === 'checkbox') {
            setFormData((prevData) => ({
                ...prevData,
                [name]: checked ? 1 : 0,
            }));
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validate()) return;

        const formPayload = new FormData();
        formPayload.append('name', formData.name);
        formPayload.append('brand', formData.brand);
        formPayload.append('status', formData.status);
        formPayload.append('featured', formData.featured);

        // **LOG BEFORE SENDING**
        console.log("Sending form data to backend...");
        for (let [key, value] of formPayload.entries()) {
            console.log(`${key}:`, value);
        }

        try {
            const response = await axios.post(
                `${APIURL.baseURL}/servicecategory.php`,
                formPayload,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            // **LOG AFTER RECEIVING RESPONSE**
            console.log("Response received from backend:", response.data);

            if (response.data.success) {
                alert('Form submitted successfully!');
                setFormData({
                    name: '',
                    thumbnail: null,
                    status: 1,
                    featured: '',
                });
            } else {
                setErrorMessage(response.data.error || 'Submission failed.');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            setErrorMessage('Submission failed. Please try again.');
        }
    };



    return (

        <div className={styles.categoryContainer}>
            <div className="container mt-4">
                <div className="row">
                    {/* Left Side: Create Category Form */}
                    <div className="col-md-6">
                        <h2>Create Service Category</h2>
                        <form onSubmit={handleSubmit}>
                            {/* Name Input */}
                            <div className={styles.formGroup}>
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Category Name"
                                    className={styles.formControl}
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            {errorMessage && (
                                <div className={styles.errorMessage}>{errorMessage}</div>
                            )}

                            {/* Brand */}
                            <div className={styles.formGroup}>
                                <input
                                    type='text'
                                    name='brand'
                                    placeholder='Enter Brand'
                                    className={styles.formControl}
                                    value={formData.brand}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            {errorMessage && (
                                <div className={styles.errorMessage}>{errorMessage}</div>
                            )}

                            {/* Status Switch */}
                            <div className={styles.switchContainer}>
                                <span className={styles.switchLabel}>Status</span>
                                <Switch
                                    checked={formData.status === 1}
                                    onChange={(e) =>
                                        handleChange({
                                            target: {
                                                name: 'status',
                                                type: 'checkbox',
                                                checked: e.target.checked,
                                            },
                                        })
                                    }
                                    name="status"
                                />
                            </div>

                            {/* Featured Dropdown */}
                            <div className={styles.formGroup}>
                                <select
                                    name="featured"
                                    placeholder="Featured"
                                    className={styles.formControl}
                                    value={formData.featured}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="" disabled>
                                        Select Featured Option
                                    </option>
                                    <option value="1">Computer</option>
                                    <option value="0">Laptop</option>
                                </select>
                            </div>

                            {/* Submit Button */}
                            <button type="submit" className={styles.submitButton}>
                                Submit
                            </button>
                        </form>
                    </div>

                    {/* Right Side: Category Table */}
                    <div className="col-md-6">
                        <ServiceCategoryTable />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddServiceCategory;